import React from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";

function Contact() {
  return (
    <div className="contact">
      <Header />
      <main>
        <div className="inner-pg">
          <div className="content">
            <h1>Contact Us</h1>
            <p>print@shiskerstone.xyz</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
